import { Box } from "@mui/material"
import PocketCuccoItem from "../inventory/items/PockeCuccoItem"
import CojiroItem from "../inventory/items/CojiroItem"
import OddMushroomItem from "../inventory/items/OddMushroomItem"
import OddPotionItem from "../inventory/items/OddPotionItem"
import SawItem from "../inventory/items/SawItem"
import PrescriptionItem from "../inventory/items/PrescriptionItem"
import EyeballFrogItem from "../inventory/items/EyeBallFrogItem"
import EyedropItem from "../inventory/items/EyedropItem"
import ClaimCheckItem from "../inventory/items/ClaimCheckItem"
import AdulTradeBackground from "../../core/assets/rsl/adultTrade.png"
import BrokenKnifeItem from "../inventory/items/BrokenKnifeItem"
interface ReworkAdultTradeSequenceTrackerProps {
    isShuffle: boolean
}

const ReworkAdultTradeSequenceTracker = (props: ReworkAdultTradeSequenceTrackerProps) => {

    if(props.isShuffle)
        return <></>;
    return <Box sx={{backgroundImage: `url(${AdulTradeBackground})`}} display={"flex"} width={"225px"} height={"100px"} justifyContent={"center"} flexWrap={"wrap"} paddingTop={"10px"} paddingBottom={"10px"} alignItems={"center"}>
        <PocketCuccoItem />
        <CojiroItem />
        <OddMushroomItem />
        <OddPotionItem />
        <SawItem />

        <Box  width={"100%"}/>

        <BrokenKnifeItem />
        <PrescriptionItem />
        <EyeballFrogItem />
        <EyedropItem />
        <ClaimCheckItem />
    </Box>
}

export default ReworkAdultTradeSequenceTracker;